import { Attachment } from "./Attachment";
import { Category, CategoryEntity } from "./Category";

export interface Question {
  _id?: string;
  title?: string;
  difficulty?: string;
  category?: CategoryEntity;
  attachment?: Attachment;
  createdAt?: Date;
}

export interface GivenAnswer {
  isCorrect: boolean;
  byPlayer: string;
}

export interface Answer {
  _id?: string;
  question?: string;
  title?: string;
  attachment?: Attachment;
}

export enum Difficulty {
  EASY = "Easy",
  MEDIUM = "Medium",
  HARD = "Hard",
}

export function difficultyStringToDifficulty(d: string): Difficulty {
  switch (d) {
    case "Easy":
      return Difficulty.EASY;
    case "Medium":
      return Difficulty.MEDIUM;
    case "Hard":
      return Difficulty.HARD;
    default:
      return Difficulty.EASY;
  }
}

export interface DifficultyInfo {
  text: string;
  color: string;
  point: number;
}

export interface GetRandomQuestionRequestModel {
  categoryId: string;
  difficulty: string;
}